export default __webpack_public_path__ + "static/media/bikersHouseWhite.42365729.png";